import { Dispatch } from 'redux'

import anchor from '../../../constants/anchor'
import { CarData, PartListSearchParams } from '../../../types/part/partTypes'
import { apiInstance } from '../../api/apiInstance'
import { RootState } from '../../store/rootReducer'

const changeCarDataForParts =
    (partsId: string[], carData: CarData, searchParams?: PartListSearchParams) =>
    async (dispatch: Dispatch, getState: () => RootState): Promise<void> => {
        const { userData } = getState()
        const config = {
            headers: {
                Authorization: `${anchor} ${localStorage.getItem('accessToken')}`,
            },
        }
        const params = {
            userId: userData.smsAuth.userId,
            partsId,
            carData,
            ...(searchParams && { params: searchParams }),
        }
        try {
            const {
                data: { status },
            } = await apiInstance.post('/changeCarDataForParts', params, config)

            if (status !== 'ok') {
                throw new Error('change carData forParts failed')
            }
        } catch (e) {
            console.error('change carData for parts failed', e)
            throw e
        }
    }

export default changeCarDataForParts
